import React, { useEffect, useRef } from 'react'

const MP_PUBLIC_KEY = 'APP_USR-6b9d586a-717c-40c5-90cc-64222cec7cb7'
const API_URL = 'https://apicursos.iteprevengo.com/api'

const MercadoPagoBrick = ({ amount, onSuccess, onError, onBeforeSubmit }) => {
    const brickRendered = useRef(false)
    const controllerRef = useRef(null)

    useEffect(() => {
        if (brickRendered.current) return
        brickRendered.current = true

        const loadBrick = async () => {
            if (!document.getElementById('mp-sdk-script')) {
                await new Promise((resolve, reject) => {
                    const script = document.createElement('script')
                    script.id = 'mp-sdk-script'
                    script.src = 'https://sdk.mercadopago.com/js/v2'
                    script.onload = resolve
                    script.onerror = reject
                    document.head.appendChild(script)
                })
            }

            const mp = new window.MercadoPago(MP_PUBLIC_KEY, { locale: 'es-PE' })
            const bricksBuilder = mp.bricks()

            if (controllerRef.current) {
                controllerRef.current.unmount()
            }

            controllerRef.current = await bricksBuilder.create('cardPayment', 'mp-card-brick-container', {
                initialization: { amount: amount },
                customization: {
                    visual: { style: { theme: 'default' } },
                    paymentMethods: { maxInstallments: 1 }
                },
                callbacks: {
                    onReady: () => console.log('Brick listo'),
                    onSubmit: (formData) => {
                        return new Promise(async (resolve, reject) => {
                            if (onBeforeSubmit) {
                                const validationError = onBeforeSubmit()
                                if (validationError !== '') {
                                    reject()
                                    return
                                }
                            }

                            try {
                                const res = await fetch(`${API_URL}/external/mp/process-payment`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify(formData)
                                })

                                const response = await res.json()

                                if (response.status === 'approved') {
                                    onSuccess(response)
                                    resolve()
                                } else {
                                    onError({ status: response.status, detail: response.status_detail })
                                    reject()
                                }
                            } catch (error) {
                                onError(error)
                                reject()
                            }
                        })
                    },
                    onError: (error) => {
                        console.error('Brick error:', error)
                        onError(error)
                    }
                }
            })
        }

        loadBrick().catch(err => {
            console.error('Error cargando MP Brick:', err)
            onError(err)
        })

        return () => {
            if (controllerRef.current) {
                controllerRef.current.unmount()
                controllerRef.current = null
                brickRendered.current = false
            }
        }
    }, [amount])

    return <div id="mp-card-brick-container"></div>
}

export default MercadoPagoBrick